module.exports = __webpack_public_path__ + "media/images/sec_5-4-4198c6bccabf2c97ae5d30e9519b171d.png";